import { Component, OnInit } from '@angular/core';
import { StorageService } from '../../services/storage.service';
import { ApiService } from '../../services/api.service';
import { UserService } from '../../services/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OtpModalComponent } from '../shared/otp-modal/otp-modal.component';
import { NotificationService } from '../../services/notification.service';
import { Router } from '@angular/router';
interface TermsSection {
  heading: string;
  subsections: string; // This is a JSON string that needs to be parsed
}

interface TermsResponse {
  type: string;
  code: number;
  message: string;
  status: string;
  data: {
    termsUpdatedDetails: {
      termsAccepted: boolean;
      termsUpdatedDate: Date;
      termsAgreeDate: Date;
    },
    terms: {
      title: string;
      sections: TermsSection[];
      intro: string;
    };
  };
}

@Component({
  selector: 'app-terms',
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
})
export class TermsComponent implements OnInit {
  termsContent: any;
  isLoading = true;
  isAgreed = false;
  title: string = '';
  intro: string = '';

  constructor(
    private apiService: ApiService,
    private store: StorageService,
    private user: UserService,
    private modalService: NgbModal,
    private notify: NotificationService,
    public router: Router
  ) {}
  // accountType = this.store.data.acc_type;

  ngOnInit() {
    this.loadTermsAndConditions();
  }

  // loadTermsAndConditions() {
  //   this.isLoading = true;

  //   this.apiService.get('retailers/getTermsAndCondition').subscribe({
  //     next: (response: TermsResponse) => {
  //       if (response?.status === 'success') {
  //         if (response?.data?.terms) {
  //           const terms = response.data.terms;
  //           this.title = terms.title;
  //           this.intro = terms.intro;

  //           try {
  //             // Parse the subsections strings into objects
  //             const sections = terms.sections.map((section) => {
  //               return {
  //                 heading: section.heading,
  //                 subsections: JSON.parse(section.subsections),
  //               };
  //             });

  //             this.termsContent = { sections };
  //           } catch (error) {
  //             console.error('Error parsing sections:', error);
  //             this.termsContent = { sections: [] };
  //           }
  //         } else {
  //           console.error('Terms data not found in response:', response.data);
  //         }
  //       } else {
  //         console.error('Invalid response status:', response?.status);
  //       }
  //       this.isLoading = false;
  //     },
  //     error: (error) => {
  //       console.error('API Error:', error);
  //       this.isLoading = false;
  //       this.notify.showError('An error occurred. Please try again.', '');
  //     },
  //   });
  // }

  loadTermsAndConditions() {
    this.isLoading = true;

    this.apiService.get('retailers/getTermsAndCondition').subscribe({
      next: (response: TermsResponse) => {
        this.isLoading = false;

        // Check for Invalid APIKEY
        if (response?.code === 2 && response?.message === 'Invalid APIKEY') {
          this.handleInvalidApiKey();
          return;
        }

        if (response?.status !== 'success') {
          return this.notify.showError('Failed to load terms.', '');
        }

        const details = response.data?.termsUpdatedDetails;
        if (!details) {
          return this.notify.showError('Terms details are missing.', '');
        }

        const { termsAccepted, termsUpdatedDate, termsAgreeDate } = details;

        const updatedDate = new Date(termsUpdatedDate);
        const agreeDate = new Date(termsAgreeDate);

        if (termsAccepted && agreeDate > updatedDate) {
          this.store.set({
            termsAccepted: true,
            termsAgreeDate: termsAgreeDate,
            termsUpdatedDate: termsUpdatedDate,
          });
          // Redirect to dashboard
          this.router.navigate(['/dashboard']);
        } else {
          this.displayTermsScreen(response.data.terms);
        }
      },
      error: (err) => {
        console.error('API Error:', err);
        this.isLoading = false;
        this.notify.showError('An error occurred. Please try again.', '');
      },
    });
  }

  // Handle logout when API key is invalid
  private handleInvalidApiKey() {
    this.notify.showError('Session expired. Please log in again.', '');

    // Call logout API but don't block flow
    this.apiService.get('retailers/logout').subscribe({
      error: (err) => console.warn('Logout API failed:', err),
    });

    // Clear user/session data and redirect
    setTimeout(() => {
      this.store.clearStore();
      this.user.reset();
      this.router.navigate(['/login']);
    }, 300);
  }

  displayTermsScreen(terms: any) {
    if (!terms) return;

    this.title = terms.title;
    this.intro = terms.intro;

    try {
      const sections = terms.sections.map((section) => ({
        heading: section.heading,
        subsections: JSON.parse(section.subsections),
      }));
      this.termsContent = { sections };
    } catch (e) {
      console.error('Error parsing sections:', e);
      this.termsContent = { sections: [] };
    }
  }

  async onTermsCheck(event: any) {
    const isChecked = event?.target?.checked;

    if (isChecked) {
      this.isAgreed = true;
      this.isLoading = true;

      // Call OTP Generate API
      this.apiService.get('retailers/approveTermsAndCondition').subscribe({
        next: async (response: TermsResponse) => {
          this.isLoading = false;

          // Open OTP Modal after successful OTP generation
          const modalRef = this.modalService.open(OtpModalComponent, {
            size: 'md',
            backdrop: 'static',
          });

          try {
            const data = await modalRef.result;
            if (data) {
              console.log('OTP Verified:', data);
              this.router.navigate(['/dashboard']);
            }
          } catch {
            // Modal dismissed or closed without verification
            console.warn('OTP modal dismissed');
          }
        },

        error: (error) => {
          this.isLoading = false;
          this.isAgreed = false;
          console.error('OTP Generation API Error:', error);
          this.notify.showError('Failed to send OTP. Please try again.', '');
        },
      });
    } else {
      this.isAgreed = false;
    }
  }
}
